import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEllipsisV,
    faChartBar
} from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { apiAssetSummary } from '../../services/apis/retail/apiAssetSummary';

class AssetSummary extends React.Component {

    state = {
        assetSummary: []
    }

    componentDidMount() {
        apiAssetSummary.get().then((res) => {
            this.setState({ assetSummary: res.data });
        });
    }


    render() {
        return (
            <div className="col-lg-6">
                <div className="widget widgetTable">
                    <div className="row">
                        <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                            <p>Asset Summary</p>
                        </div>
                        <div className="col-lg-3 text-end">
                            <Link to="/#" className="pe-3">
                                <FontAwesomeIcon icon={faChartBar} />
                            </Link>
                            <Link to="/#" className="colorBlack">
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </Link>
                        </div>
                        <div className="col-lg-12 mt-2">
                            <Table responsive hover>
                                <thead>
                                    <tr className="tableTdColor">
                                        <th>Type</th>
                                        <th>Projects</th>
                                        <th>Total Area (msf)</th>
                                        <th>% Contribution</th>
                                        <th>Vacancy</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.assetSummary.map((row, i) => (
                                        <tr className="tableTdColor" key={i}>
                                            <td>{row.asset_type}</td>
                                            <td>{row.project}</td>
                                            <td>{row.total_area}</td>
                                            <td>{row.perc_contribution}</td>
                                            <td>{row.vacancy}%</td>
                                        </tr>
                                    ))}
                                    {/* <tr className="tableTdColor">
                            <td>Non IT</td>
                            <td>219</td>
                            <td>290</td>
                            <td>38</td>
                            <td>14%</td>
                          </tr>
                          <tr className="tableTdColor">
                            <td>Non IT</td>
                            <td>219</td>
                            <td>290</td>
                            <td>38</td>
                            <td>14%</td>
                          </tr>
                          <tr className="tableTdColor">
                            <td>Non IT</td>
                            <td>219</td>
                            <td>290</td>
                            <td>38</td>
                            <td>14%</td>
                          </tr> */}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default AssetSummary;
